import { PieChart, Pie, Cell, ResponsiveContainer, Legend } from "recharts";

export function SpendingChartCard({categoryShares, totalSpending}) {

  const COLOR_PALETTE = [
    "var(--chart-1)",
    "var(--chart-2)",
    "var(--chart-3)",
    "var(--chart-4)",
    "var(--chart-5)",
    "var(--chart-6)",
    "var(--chart-7)",
    "var(--chart-8)",
  ];

  const categoryList = categoryShares && categoryShares.data ? categoryShares.data : [];

  const data = categoryList.map((item, index) => ({
    name: item.categoria_nome,
    value: item.percentage_share,
    color: COLOR_PALETTE[index % COLOR_PALETTE.length],
  }));

  const renderCustomLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent }) => {
    const RADIAN = Math.PI / 180;
    const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
    const x = cx + radius * Math.cos(-midAngle * RADIAN);
    const y = cy + radius * Math.sin(-midAngle * RADIAN);

    return (
      <text 
        x={x} 
        y={y} 
        fill="white" 
        textAnchor={x > cx ? 'start' : 'end'} 
        dominantBaseline="central"
        className="small fw-medium"
      >
        {`${(percent * 100).toFixed(0)}%`}
      </text>
    );
  };

  const CustomLegend = ({ payload }) => (
    <div className="row g-2 mt-3">
      {payload.map((entry, index) => (
        <div key={index} className="col-6">
          <div className="chart-legend-item">
            <div
              className="chart-legend-dot"
              style={{ backgroundColor: entry.color }}
            />
            <span>{entry.value}</span>
          </div>
        </div>
      ))}
    </div>
  );

  return (
    <div className="card custom-card h-100">
      <div className="card-body p-4">
        <h3 className="h5 fw-semibold mb-4">Gastos por Categoria</h3>
        
        <div style={{ height: '300px' }}>
          <ResponsiveContainer width="100%" height="100%">
            <PieChart>
              <Pie
                data={data}
                cx="50%"
                cy="50%"
                labelLine={false}
                label={renderCustomLabel}
                outerRadius={80}
                innerRadius={40}
                fill="#8884d8"
                dataKey="value"
                stroke="none"
              >
                {data.map((entry, index) => (
                  <Cell
                    key={`cell-${index}`}
                    fill={entry.color}
                  />
                ))}
              </Pie>
              <Legend content={<CustomLegend />} />
            </PieChart>
          </ResponsiveContainer>
        </div>
        
        <div className="summary-box mt-4">
          <div className="d-flex justify-content-between align-items-center">
            <span className="small text-muted-custom">Gastos Totais</span>
            <span className="fw-semibold">
              R${(totalSpending ?? 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}